import * as firebase from 'firebase';
import {restService} from '../../controllers/rest.js';
var restServiceInstance = new restService();
const state = {
  user: null,
  errorLogin: '',
  verifyingUser: false,
  accessList: {},
};
const getters = {
  user(state) {
    return state.user;
  },
  errorMsgLogin(state) {
    return state.errorLogin;
  },
  verifyingUser(state) {
    return state.verifyingUser;
  },
  accessList(state) {
    return state.accessList;
  },
};
const mutations = {
  setUser(state, payload) {
    state.user = payload;
  },
  setVerifyingUser(state, payload) {
    state.verifyingUser = payload;
  },
  errorLogin(state, errorMsg) {
    state.errorLogin = errorMsg;
  },
  clearError(state) {
    state.errorLogin = null;
  },
  setAccessList(state, payload) {
    state.accessList = payload;
  },
};
const actions = {
  signUserIn({ commit }, payload) {
    firebase
      .auth()
      .signInWithEmailAndPassword(payload.email, payload.password)
      .then((user) => {
        restServiceInstance
          .getUser(payload.email)
          .then((user) => {
            const newUser = {
              id: user.uid,
              email: payload.email,
              name: user[0].name,
            };
            commit('setUser', newUser);
          })
          .catch((error) => {
            console.log(error.response);
            commit('errorLogin', error.response.data);
          });
      })
      .catch((error) => {
        commit('errorLogin', error.code);
        console.log(error);
      });
  },
  singUserOut({ commit }) {
    firebase
      .auth()
      .signOut()
      .then(() => {
        commit('setUser', null);
      });
  },
  fetchUserAccesList({ commit }, payload) {
    console.log('FETCH: ', payload);
    firebase
      .database()
      .ref('users')
      .child(payload.uid)
      .once('value')
      .then((usersSnapshot) => {
        console.log(usersSnapshot.val().permisos);
        commit('setAccessList', usersSnapshot.val().permisos);
      });
  },
  tryAutoLogin({ commit }) {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        const newUser = {
          id: user.uid,
        };
        commit('setUser', newUser);
      }
    });
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
